import React from 'react'
import { ManagementItemIconUi } from './ui/management-item-icon-ui'
import { ManagementItemTitleUi } from './ui/management-item-title-ui'
import { ManagementItemUi } from './ui/management-item-ui'

export interface ManagementItemProps {
  id: string
  title: string
  display: (id: string) => void
  remove: (id: string) => void
}

export const ManagementItem = ({
  remove,
  id,
  display,
  title,
}: ManagementItemProps) => {
  const onDisplayClick = () => display(id)
  const onRemoveClick = () => remove(id)

  return (
    <ManagementItemUi>
      <ManagementItemTitleUi>{title}</ManagementItemTitleUi>
      <div>
        <ManagementItemIconUi className="fa fa-eye" onClick={onDisplayClick} />
        <ManagementItemIconUi className="fa fa-trash" onClick={onRemoveClick} />
      </div>
    </ManagementItemUi>
  )
}
